<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('menu.orderTypeMaintain')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 8 }" :model="data" :rules="rules" :wrapper-col="{ span: 16 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.no')" prop="no">
            <vxe-input v-model="data.no" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.name')" prop="name">
            <vxe-input v-model="data.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.parent')">
            <vxe-select v-model="data.parent.id" :options="orderTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.operationType')" prop="operationType">
            <vxe-select v-model="data.operationType" :options="operationTypes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.native')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.original"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.refundable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.refundable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.depositable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.depositable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.coding')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.coding"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.chargeup')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.chargeup"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.inspectable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.inspectable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.producible')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.producible"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.shortable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.shortable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.delegable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.delegable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.exchangeable')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.exchangeable"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.invertible')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.invertible"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.convertible')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.convertible"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.supplemental')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.supplemental"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.temporary')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.temporary"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.supervised')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.supervised"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.mergeOrder')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.mergeOrder"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoSubmit')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoSubmit"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoApproval')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoApproval"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoAsn')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoAsn"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoReceiving')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoReceiving"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoAccepting')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoAccepting"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoPutaway')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoPutaway"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoCompletion')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoCompletion"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoRetry')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoRetry"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoInversionApproval')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoInversionApproval"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoReview')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoReview"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoDistribution')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoDistribution"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoHandover')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoHandover"/>
          </a-form-model-item>
        </a-col>
        <a-col span="6">
          <a-form-model-item :label="$t('business.label.autoCleanup')" :label-col="{ span: 16 }" :wrapper-col="{ span: 8 }">
            <vxe-switch v-model="data.autoCleanup"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { OrderType } from '@/api/dto/common/OrderType'

export default {
  name: 'OrderTypeEditor',
  props: {
    orderTypes: { type: Array, default: [] },
    operationTypes: { type: Array, default: [] }
  },
  data() {
    return {
      enterprise: Vue.ls.get(ENTERPRISE),
      visible: false,
      loading: false,
      data: new OrderType(),
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        operationType: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  methods: {
    add() {
      this.visible = true
      this.data = new OrderType()
      this.data.available = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('orderTypeFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new OrderType(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      data.enterprise = this.enterprise
      save('orderTypePersister', data).then(res => {
        if (res.success) {
          this.data = new OrderType(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>